// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePicker_container__3n_Qp","label":"DatePicker_label__3fd8J","picker":"DatePicker_picker__2kR33","star":"DatePicker_star__2JTNg"};